export const PAUSE_CHAT = 'pauseChat';
export const RESUME_CHAT = 'resumeChat';
export const MESSAGE_SENT = 'messageSent';
export const USERNAME_SELECTED = 'usernameSelected';
export const CREATE_SIGNUP = 'createSignup';
